export const sidebarConfig = {
  "safety-inspection": [
    {
      title: "Programs",
      link: "/safety-inspection",
      validations: [],
    },
    {
      title: "Subscription Management",
      link: "/safety-inspection/subscription",
      validations: [],
    },
    {
      title: "Help Center",
      link: "/safety-inspection/help-center",
      validations: [],
    },
    {
      title: "Settings",
      link: "/safety-inspection/settings",
      validations: [],
    },
  ],
  admin: [],
};

export const sortOptions = [
  { label: "Name Ascending", value: "name:asc" },
  { label: "Name Descending", value: "name:desc" },
  { label: "Date Oldest", value: "createDate:asc" },
  { label: "Date Newest", value: "createDate:desc" },
];

export const getOrderByObject = (orderBy) => {
  const orderByValues = orderBy?.split(":");
  let sortObject = {};

  if (orderByValues?.length) {
    sortObject = {
      [orderByValues[0]]: orderByValues[1],
    };
  }

  return sortObject;
};
